import React, { useContext } from 'react';
import classNames from 'classnames';
import { Link } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { AppContext } from 'contexts';
import ReactPixel from 'react-facebook-pixel';
import 'styles/animations.scss';

const useStyles = makeStyles({
  infoPropertyBox: {
    position: 'absolute',
    display: 'none',
    top: 61,
    left: 0,
    backgroundColor: 'white',
    padding: 30,
    animation: 'slide-down .2s ease-in',

    '@media (max-width: 767px)': {
      top: 101,
    },

    '&.open': {
      display: 'block',
    },
  },
  closeButton: {
    position: 'absolute',
    top: 15,
    right: 15,
    cursor: 'pointer',
  },
  brokerInfoBox: {
    display: 'flex',
    alignItems: 'flex-start',
  },
  brokerInfo: {
    marginLeft: 24,
    fontSize: 18,
    display: 'flex',
    flexDirection: 'column',
    textAlign: 'left',
  },
  contactBox: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'flex-start',
    marginTop: 20,
  },
  contactInfo: {
    marginLeft: 24,
    fontSize: 18,
    display: 'flex',
    flexDirection: 'column',
    textAlign: 'left',
  },
});

function InfoProperty() {
  const classes = useStyles();
  const appContext = useContext(AppContext);

  const { listing, getInfoPropertyDisplay, setInfoPropertyDisplay } = appContext;

  const infoPropertyDisplay = getInfoPropertyDisplay();

  const broker = listing ? listing.broker : null;
  const firstName = broker ? broker.firstname : '';
  const brokerPortalInfo =
    broker && broker.broker_portal_info ? broker.broker_portal_info : {};
  const brokerDomainName = brokerPortalInfo.domain_name
    ? brokerPortalInfo.domain_name
    : null;
  const brokerServicePage = brokerDomainName ? `https://${brokerDomainName}` : null;
  const lastName = broker ? broker.lastname : '';
  const email = broker ? broker.email : '';
  const phoneNumber = broker ? broker.phone_number : '';

  const city = listing ? listing.city : '';
  const address = listing ? listing.address : '';
  const appartement = listing && listing.app ? `${listing.app}-` : '';

  const onClose = () => {
    setInfoPropertyDisplay(false);
  };

  return (
    <div className={classNames(classes.infoPropertyBox, { open: infoPropertyDisplay })}>
      <div className={classes.closeButton}>
        <img
          src='/images/xIcon.png'
          alt='Fermer'
          onClick={onClose}
          onTouchEnd={onClose}
        />
      </div>
      <div className={classes.brokerInfoBox}>
        <img src='/images/brokerIcon.png' alt='broker' />
        <div className={classes.brokerInfo}>
          <div>{`${firstName} ${lastName}`}</div>
          <div>
            <Link
              href={`mailto:${email}`}
              style={{ color: 'black' }}
              onClick={() => {
                ReactPixel.track('Contact', {
                  content_name: listing.address,
                });
              }}
            >
              {email}
            </Link>
          </div>
          <div>{phoneNumber}</div>
        </div>
      </div>
      {brokerServicePage ? (
        <div className={classes.contactBox}>
          <img src='/images/web.svg' height={20} width={20} alt='web' />
          <div className={classes.brokerInfo}>
            <Link
              href={brokerServicePage}
              style={{ color: 'black', textDecoration: 'underline' }}
              target='_blank'
              rel='noopener'
            >
              Portail
            </Link>
          </div>
        </div>
      ) : null}
      <div className={classes.contactBox}>
        <img src='/images/locIcon.png' alt='broker' />
        <div className={classes.contactInfo}>{`${appartement}${address} ${city}`}</div>
      </div>
    </div>
  );
}

export default InfoProperty;
